import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, of, Subject, Subscription } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { FormBuilder, Validators } from '@angular/forms';
import { PlantService } from '../../../../../core/plant-configuration/_services/plant.service';
import { AuthService } from '../../../../../core/auth';
import { CompanyService } from '../../../../../core/auth/_services/company.service';
import { ProductTypeService } from '../../../../../core/plant-configuration/_services/product-type.service';
import { ProductPackageService } from '../../../../../core/plant-configuration/_services/product-package.service';
import { ProductPackageWeightService } from '../../../../../core/plant-configuration/_services/product-package-weight.service';
import { ProductPackageUnitService } from '../../../../../core/plant-configuration/_services/product-package-unit.service';
import { ProductProcessService } from '../../../../../core/plant-configuration/_services/product-process.service';
import { ProductService } from '../../../../../core/plant-configuration';
import { ProductionLineService } from '../../../../../core/plant-configuration/_services/production-line.service';

@Component({
  selector: 'kt-production-line-edit',
  templateUrl: './production-line-edit.component.html',
  styleUrls: []
})
export class ProductionLineEditComponent implements OnInit, OnDestroy, AfterViewInit {
  itemObs = new Subject<any[]>();
  editObs = new Subject<number>();
  addObs = new Subject<number>();
  private itemFormOptions = {
    name: ["", Validators.required]
    // company_id: ["-1", Validators.required],
  };
  itemForm = this.formBuilder.group(this.itemFormOptions);
  stepList: any[] = [
    {
      icon: "flaticon2-architecture-and-city", title: "Datos de la linea de producción", subTitle: "Ingrese nombre de la linea de producción", form: [
        [
          { name: "name", label: "Nombre", type: "text" },
        ],
      ]
	}
  ];

	private subscriptions: Subscription[] = [];
	data: any = {};
	partnerList: any[];
	userList: any[];
	uid: number = -1;
	company: any = null;
	packageList: any[] = [];
	productTypeList: any[] = [];
	unitList: any[] = [];
	weightList: any[] = [];
	processList: any[] = [];

  constructor(
    private productionLineService: ProductionLineService,
    // private companyService: CompanyService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.uid = this.authService.getUID();
	
  }
  ngAfterViewInit() {

  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  onItemLoaded(item) {

    console.log("on item load:");
	console.dir(item);
  }

  getItem(itemId: number) {
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.productionLineService.getById(itemId))
      ).subscribe(item => {
        this.onItemLoaded(item);
        this.itemObs.next(item);
      })
    )
  }

  addItem(item: any) {
    item.create_uid = this.uid>0?this.uid:'null';
    item.create_date = "now()";
    // item.is_installation_contact = 'true';
    // item.active = 'true';
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.productionLineService.add(item))
      ).subscribe(newId => {
        this.addObs.next(newId);
      })
    )
  }

  editItem(item: any) {
    item.write_uid = this.uid>0?this.uid:'null';
    item.write_date = "now()";
    // item.is_installation_contact = 'true';
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.productionLineService.edit(item))
      ).subscribe(status => {
        if (status == "success") this.editObs.next(item.id);
        else this.editObs.next(-1);
      })
    )
  }
}